var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightTickMarkPopup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 95,
    viewBox: "0 0 97 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17526_335)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.998,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.0488 -0.09375C46.9537 -0.09375 49.8588 -0.09375 52.7637 -0.09375C71.6656 2.30882 85.1484 11.9573 93.2119 28.8516C95.1322 33.4678 96.3637 38.2302 96.9062 43.1387C96.9062 45.9837 96.9062 48.8288 96.9062 51.6738C94.453 70.186 84.6015 83.3908 67.3516 91.2881C62.6383 93.1688 57.7757 94.3748 52.7637 94.9062C49.8588 94.9062 46.9537 94.9062 44.0488 94.9062C25.1465 92.5032 11.6638 82.8548 3.60059 65.9609C1.68027 61.3447 0.448829 56.5823 -0.09375 51.6738C-0.09375 48.8288 -0.09375 45.9837 -0.09375 43.1387C2.3594 24.6265 12.211 11.4217 29.4609 3.52441C34.1743 1.6437 39.037 0.437641 44.0488 -0.09375Z",
    fill: "url(#paint0_linear_17526_335)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3516 25.1403C67.9756 25.0956 68.544 25.2502 69.0566 25.6042C71.5512 28.0473 74.0455 30.4902 76.54 32.9333C76.9352 33.7065 76.8722 34.4487 76.3506 35.1599C64.6941 46.638 52.9795 58.0491 41.207 69.3933C40.5756 69.7644 39.9439 69.7644 39.3125 69.3933C32.8974 63.1722 26.5507 56.8946 20.2725 50.5603C19.8936 49.9418 19.8936 49.3232 20.2725 48.7048C22.8301 46.1999 25.3877 43.695 27.9453 41.1901C28.5768 40.819 29.2084 40.819 29.8398 41.1901C33.25 44.53 36.6602 47.8698 40.0703 51.2097C40.2598 51.3334 40.4492 51.3334 40.6387 51.2097C49.5231 42.4775 58.4274 33.7877 67.3516 25.1403Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17526_335",
    x1: 48.4062,
    y1: -0.09375,
    x2: 48.4063,
    y2: 94.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BAE4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F4821"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17526_335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 95,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTickMarkPopup);
export default __webpack_public_path__ + "static/media/rightTickMarkPopup.51643032fa29edcda958a850debb4619.svg";
export { ForwardRef as ReactComponent };